import { useScrollReveal } from '../hooks/useScrollReveal';
import { useParallax } from '../hooks/useParallax';

const outputItems = [
  { label: '内容模型', desc: '理论阐释 结构逻辑 案例转化 教学目标 专题咬合', alignTo: '专家面板 ~0.365', icon: 'ri-file-text-line', color: 'primary' },
  { label: '感染力模型', desc: '表达节奏 课堂体验 价值感受 教学效果', alignTo: '学生面板 ~0.553', icon: 'ri-heart-pulse-line', color: 'accent' },
];

const outputCards = [
  { label: '综合总分', icon: 'ri-medal-line', desc: '快速概览' },
  { label: '维度分', icon: 'ri-bar-chart-2-line', desc: '解释结构' },
  { label: '三档结果', icon: 'ri-stack-line', desc: '资源配置' },
  { label: '证据链', icon: 'ri-links-line', desc: '回答"为什么"' },
  { label: '改进建议', icon: 'ri-lightbulb-line', desc: '转化为教学行动' },
];

export default function P37EvaluationOutput({ forceVisible = false }: { forceVisible?: boolean }) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.12, forceVisible);
  const { ref: orb1Ref, offset: orb1Y } = useParallax(0.05);
  const { ref: orb2Ref, offset: orb2Y } = useParallax(-0.04);

  return (
    <div className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-background-50">
      <div ref={orb1Ref} className="absolute top-20 right-24 w-80 h-80 rounded-full bg-primary-100/10 blur-[100px] pointer-events-none" style={{ transform: `translateY(${orb1Y}px)` }} />
      <div ref={orb2Ref} className="absolute bottom-28 left-12 w-96 h-96 rounded-full bg-accent-100/8 blur-[120px] pointer-events-none" style={{ transform: `translateY(${orb2Y}px)` }} />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-10 md:py-12">
        <div ref={titleRef} className="text-center mb-5 md:mb-7">
          <span className="inline-block text-xs font-body font-semibold text-accent-600 uppercase tracking-[0.15em] mb-3 transition-all duration-700">评价输出</span>
          <h2 className="font-heading text-2xl md:text-4xl lg:text-[2.75rem] font-bold text-foreground-950 transition-all duration-1000 delay-100">
            内容模型、感染力模型与<span className="text-primary-600">融合结果</span>
          </h2>
        </div>

        {/* 双轨 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto mb-6 transition-all duration-1000 delay-200">
          {outputItems.map((item) => (
            <div key={item.label} className={`p-5 rounded-2xl ${item.color === 'primary' ? 'glass-liquid border-primary-200/30' : 'glass-liquid-gold border-accent-200/30'}`}>
              <div className="relative z-10">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${item.color === 'primary' ? 'glass-blue border-primary-200/40' : 'glass-gold border-accent-200/40'}`}>
                    <i className={`${item.icon} text-base ${item.color === 'primary' ? 'text-primary-600' : 'text-accent-600'}`} />
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-bold text-foreground-800">{item.label}</h3>
                    <p className="text-[10px] text-foreground-400">对齐：{item.alignTo}</p>
                  </div>
                </div>
                <p className="text-xs text-foreground-500 font-body leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* 融合结果数据 */}
        <div className="max-w-3xl mx-auto mb-5 text-center transition-all duration-1000 delay-400">
          <div className="p-4 rounded-2xl glass-strong border-primary-200/30">
            <p className="font-heading text-sm font-bold text-foreground-800 mb-1">两轨融合</p>
            <p className="text-xs text-foreground-500 font-body">
              价签加权融合后对综合金标一致性约<span className="font-bold text-primary-700">0.800</span>，留一验证均值约<span className="font-bold text-primary-700">0.793</span>
            </p>
            <p className="text-[10px] text-foreground-400 mt-1">本科样本11门，结果用于方法验证；0.800是排序一致性非准确率</p>
          </div>
        </div>

        {/* 五项输出 */}
        <div className="max-w-5xl mx-auto transition-all duration-1000 delay-600">
          <div className="grid grid-cols-3 md:grid-cols-5 gap-2.5">
            {outputCards.map((card) => (
              <div key={card.label} className="p-3 rounded-2xl glass border-white/50 text-center hover:border-primary-200/40 transition-all duration-300">
                <i className={`${card.icon} text-base text-primary-500 mb-1`} />
                <p className="text-[11px] font-body font-bold text-foreground-800">{card.label}</p>
                <p className="text-[10px] text-foreground-400">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}